export enum DtwinSelectionQuickFilter {
  ALL_DEVICES = "allDevices",
  SELECTED_DEVICES = "selectedDevices",
  UNSELECTED_DEVICES = "unselectedDevices",
}
